import { Injectable } from '@angular/core';
import { AuthenticationNgRxActions } from '@geekbears/gb-ngrx-auth-basic';
import { MembershipActions } from '@modules/company-manager/membership/application';
import { UsersActions } from '@modules/company-manager/users/application';
import { Actions, EffectsModule, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

@Injectable()
export class AppEffects {
  constructor(private store$: Store, private actions$: Actions) {}

  refetchUserInfoWhenSubscriptionChanges$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        MembershipActions.subscribeToPlanSuccess,
        MembershipActions.subscribeToPlanFailure,
        UsersActions.updateCompanyManagerFailure,
        UsersActions.updateCompanyManagerSuccess
      ),
      map(() => {
        return AuthenticationNgRxActions.getAuthenticatedUserData();
      })
    );
  });
}

export const AppEffectsModule = EffectsModule.forFeature([AppEffects]);
